// SPDX-FileCopyrightText: 2026 Angels' Ware
// SPDX-License-Identifier: AGPL-3.0-or-later

// Saving a file the app has already fetched.
//
// Every download here is data the browser holds in memory, not a URL it can be
// pointed at: the endpoints need the Authorization header, which a plain anchor
// cannot send, and the CSV is built client-side and doesn't exist server-side at
// all. So the file is assembled into a blob, handed to a transient object URL,
// and clicked.
//
// It exists once because the dance has a leak-if-you-forget step
// (revokeObjectURL) and a needs-to-be-in-the-document step (Firefox ignores a
// click on a detached anchor).

// downloadBlob saves bytes the app already holds. The two callers that reach
// for it hold a Blob rather than a string — a file fetched from the workspace
// endpoint, which needs the Authorization header a plain anchor cannot send.
export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  try {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    // Firefox won't act on a click on an anchor outside the document.
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    // In a finally: an exception between creating the URL and clicking would
    // otherwise leak the blob for the lifetime of the document.
    URL.revokeObjectURL(url);
  }
}

export function downloadText(text: string, mime: string, filename: string) {
  downloadBlob(new Blob([text], { type: mime }), filename);
}

export function downloadJson(data: unknown, filename: string) {
  downloadText(JSON.stringify(data, null, 2), "application/json", filename);
}
